/* Saint Ferro — Fluessiges Metall auf den Hero-Texten und dem Logo.
   FERRO, SAINT, die Tagline UND das SF-Logo laufen ueber DENSELBEN WebGL-Shader:
   das Metall wellt sich unter dem Zeiger und erstarrt danach wieder.

   Die echten Elemente bleiben im DOM und werden nur unsichtbar gesetzt
   -> Text bleibt crawlbar, das Logo-Bild bleibt als Fallback stehen, wenn
   WebGL fehlt, reduced motion aktiv ist oder das Bild nicht gezeichnet werden kann.

   Logo: AUS seit 11.09.2026 auf Leons Wunsch (siehe specs unten). Der Code fuer
   Bild-Texturen bleibt drin.
   Logo-Modus: die Form kommt aus dem Alpha des Bildes, die Chrom-Zeichnung
   aus seiner Helligkeit (uDetail, nur zu 55 %, sonst ueberdeckt sie den Glanz).
   uFlow laesst das Logo dauerhaft fliessen - auch ohne Maus, also am Handy.
   Fuer Text sind uDetail und uFlow 0, das Bild dort ist unveraendert.

   ACHTUNG beim Bearbeiten ueber die API: Shader-Zeilen mit String.fromCharCode(10)
   verbinden, NIE mit einem Backslash-n-Literal. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var weak = navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2;
  if (reduce || saveData || weak) return;

  var NL = String.fromCharCode(10);

  var VERT = 'attribute vec2 p;varying vec2 v;void main(){v=vec2((p.x+1.)*.5,1.-(p.y+1.)*.5);gl_Position=vec4(p,0.,1.);}';

  var FRAG = [
    'precision mediump float;',
    'varying vec2 v;',
    'uniform sampler2D uTex;',
    'uniform vec2 uMouse;',
    'uniform float uTime;',
    'uniform float uInf;',
    'uniform float uAspect;',
    'uniform float uAmp;',
    'uniform float uGold;',
    'uniform float uDetail;',
    'uniform float uFlow;',
    'void main(){',
    '  vec2 a=vec2((v.x-uMouse.x)*uAspect, v.y-uMouse.y);',
    '  float d=length(a);',
    '  float w=sin(d*26.0-uTime*5.0)*exp(-d*5.5)*uAmp*uInf;',
    '  vec2 dir = d>0.0001 ? normalize(a) : vec2(0.0);',
    '  vec2 uv=v+dir*w;',
    '  uv.x += sin(v.y*18.0+uTime*0.5)*uAmp*0.05;',
    '  uv.x += sin(v.y*11.0+uTime*1.7)*uAmp*0.45*uFlow;',
    '  uv.y += cos(v.x*9.0+uTime*1.3)*uAmp*0.30*uFlow;',
    '  vec4 texc=texture2D(uTex,uv);',
    '  float alpha=texc.a;',
    '  if(alpha<0.01){discard;}',
    '  float band=fract(uv.y*1.6+uv.x*0.6*uFlow-uTime*(0.05+0.22*uFlow));',
    '  float ramp=smoothstep(0.0,0.5,band)*(1.0-smoothstep(0.5,1.0,band));',
    '  vec3 bone=vec3(0.918,0.906,0.874);',
    '  vec3 steel=vec3(0.396,0.427,0.470);',
    '  vec3 goldHi=vec3(1.0,0.914,0.722);',
    '  vec3 goldLo=vec3(0.478,0.361,0.118);',
    '  vec3 col=mix(mix(steel,bone,ramp), mix(goldLo,goldHi,ramp), uGold);',
    '  vec3 hot=vec3(0.784,0.627,0.294);',
    '  float heat=exp(-d*7.0)*uInf;',
    '  col=mix(col,hot,heat*0.55*(1.0-uGold));',
    '  col += vec3(1.0)*pow(ramp,6.0)*0.35;',
    '  float lum=dot(texc.rgb,vec3(0.299,0.587,0.114));',
    '  col=mix(col, col*(0.55+0.75*lum)+vec3(0.12)*pow(lum,4.0), uDetail);',
    '  gl_FragColor=vec4(col,alpha);',
    '}'
  ].join(NL);

  // Zeiger einmal global verfolgen, alle Instanzen lesen davon
  var pointer = { x: -9999, y: -9999, active: false };
  window.addEventListener('pointermove', function (e) {
    pointer.x = e.clientX; pointer.y = e.clientY; pointer.active = true;
  }, { passive: true });
  window.addEventListener('pointerleave', function () { pointer.active = false; });

  var baseStyle = new Map();

  function makeMolten(el, opts) {
    var isImg = el.tagName === 'IMG';
    var host = isImg ? el.parentElement : el;
    if (!host) return null;

    // Text: NUR direkte Textknoten, sonst kaeme der unsichtbare SEO-Zusatz
    // bzw. der Echo-Span mit (FERROFERRO).
    var text = '';
    if (!isImg) {
      text = Array.prototype.filter.call(el.childNodes, function (n) { return n.nodeType === 3; })
        .map(function (n) { return n.textContent; }).join(' ').trim();
      if (!text) return null;
    }

    var canvas = document.createElement('canvas');
    canvas.className = 'sf-molten-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    var gl = canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false });
    if (!gl) return null;

    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        if (window.console && console.warn) console.warn('[sf-molten]', gl.getShaderInfoLog(s));
        return null;
      }
      return s;
    }
    var vs = compile(gl.VERTEX_SHADER, VERT), fs = compile(gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return null;
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

    var U = {
      tex: gl.getUniformLocation(prog, 'uTex'),
      mouse: gl.getUniformLocation(prog, 'uMouse'),
      time: gl.getUniformLocation(prog, 'uTime'),
      inf: gl.getUniformLocation(prog, 'uInf'),
      aspect: gl.getUniformLocation(prog, 'uAspect'),
      amp: gl.getUniformLocation(prog, 'uAmp'),
      gold: gl.getUniformLocation(prog, 'uGold'),
      detail: gl.getUniformLocation(prog, 'uDetail'),
      flow: gl.getUniformLocation(prog, 'uFlow')
    };
    gl.uniform1i(U.tex, 0);
    gl.uniform1f(U.gold, opts.gold ? 1 : 0);
    gl.uniform1f(U.detail, opts.detail || 0);
    gl.uniform1f(U.flow, opts.flow || 0);

    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    var off = document.createElement('canvas');
    var octx = off.getContext('2d');
    var ready = false, pad = opts.pad, retry = null, failed = false;

    function build() {
      if (failed) return;
      var r = el.getBoundingClientRect();
      if (r.width < 4 || r.height < 4) { setTimeout(build, 60); return; }

      if (isImg) {
        // Bild erst zeichnen, wenn es geladen ist
        if (!(el.complete && el.naturalWidth)) { el.addEventListener('load', build, { once: true }); return; }
      } else {
        var base0 = baseStyle.get(el);
        // Mehrzeilig? Das Canvas zeichnet EINE Zeile - bei Umbruch passt es nicht
        // zum Text. Dann Effekt aussetzen und den normalen Text wieder zeigen.
        if (r.height > base0.size * 1.9) {
          canvas.style.display = 'none';
          el.style.color = '';
          ready = false;
          // Selbst heilen: wird wieder Platz frei, kommt das Metall zurueck.
          clearTimeout(retry); retry = setTimeout(build, 600);
          return;
        }
        el.style.color = 'transparent';
      }
      canvas.style.display = '';

      // Kleiner Text braucht mehr Pixel, sonst wird das Metall zu Matsch
      var dpr = Math.min(window.devicePixelRatio || 1, 2) * opts.sharpen;
      var padX = r.width * pad, padY = r.height * pad;
      var w = Math.round((r.width + padX * 2) * dpr);
      var h = Math.round((r.height + padY * 2) * dpr);
      off.width = w; off.height = h;
      canvas.width = w; canvas.height = h;
      if (isImg) {
        var hr = host.getBoundingClientRect();
        canvas.style.left = (r.left - hr.left - padX) + 'px';
        canvas.style.top = (r.top - hr.top - padY) + 'px';
      } else {
        canvas.style.left = (-padX) + 'px';
        canvas.style.top = (-padY) + 'px';
      }
      canvas.style.width = (r.width + padX * 2) + 'px';
      canvas.style.height = (r.height + padY * 2) + 'px';
      gl.viewport(0, 0, w, h);

      octx.setTransform(1, 0, 0, 1, 0, 0);
      octx.clearRect(0, 0, w, h);
      octx.scale(dpr, dpr);

      if (isImg) {
        // wie object-fit: contain in der Box des Bildes
        var nw = el.naturalWidth, nh = el.naturalHeight;
        var s = Math.min(r.width / nw, r.height / nh);
        var dw = nw * s, dh = nh * s;
        octx.drawImage(el, padX + (r.width - dw) / 2, padY + (r.height - dh) / 2, dw, dh);
      } else {
        var cs = baseStyle.get(el);
        octx.font = cs.style + ' ' + cs.weight + ' ' + cs.size + 'px ' + cs.family;
        octx.textAlign = 'center';
        octx.textBaseline = 'middle';
        octx.fillStyle = '#fff';
        var ls = cs.ls;
        var hasLS = ('letterSpacing' in octx);
        if (ls && hasLS) octx.letterSpacing = ls + 'px';
        var cx = (r.width + padX * 2) / 2, cy = (r.height + padY * 2) / 2;
        if (!ls || hasLS) {
          octx.fillText(text, cx, cy);
        } else {
          var total = 0, i;
          for (i = 0; i < text.length; i++) total += octx.measureText(text[i]).width + ls;
          total -= ls;
          var x = cx - total / 2;
          for (i = 0; i < text.length; i++) {
            var cw = octx.measureText(text[i]).width;
            octx.fillText(text[i], x + cw / 2, cy);
            x += cw + ls;
          }
        }
      }

      try {
        gl.bindTexture(gl.TEXTURE_2D, tex);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, off);
      } catch (e) {
        // z. B. Bild von fremder Domain: Effekt aus, Original bleibt sichtbar
        failed = true; ready = false;
        canvas.style.display = 'none';
        if (isImg) el.style.opacity = ''; else el.style.color = '';
        if (window.console && console.warn) console.warn('[sf-molten] Textur:', e && e.message);
        return;
      }
      gl.uniform1f(U.aspect, w / h);
      gl.uniform1f(U.amp, opts.amp);
      if (isImg) el.style.opacity = '0';
      ready = true;
    }

    var inf = 0, t0 = performance.now(), running = false, visible = true;

    function frame(now) {
      if (!running) return;
      var r = canvas.getBoundingClientRect();
      var mx = 0.5, my = 0.5, target = 0;
      if (pointer.active && r.width) {
        mx = (pointer.x - r.left) / r.width;
        my = (pointer.y - r.top) / r.height;
        if (mx > -0.6 && mx < 1.6 && my > -1.2 && my < 2.2) target = 1;
      }
      inf += (target - inf) * 0.075;
      gl.uniform2f(U.mouse, mx, my);
      gl.uniform1f(U.time, (now - t0) / 1000);
      gl.uniform1f(U.inf, inf);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      if (ready) gl.drawArrays(gl.TRIANGLES, 0, 3);
      requestAnimationFrame(frame);
    }
    function start() { if (!running && visible) { running = true; requestAnimationFrame(frame); } }
    function stop() { running = false; }

    host.classList.add('sf-molten-host');
    if (!isImg) {
      var echo = el.querySelector('[class*="ai-echo-"]');
      if (echo) echo.style.opacity = '0';
    }
    host.appendChild(canvas);

    if ('ResizeObserver' in window) new ResizeObserver(build).observe(el);
    var wr; window.addEventListener('resize', function () { clearTimeout(wr); wr = setTimeout(build, 180); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; visible ? start() : stop(); }, { threshold: 0 }).observe(host);
    }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    build(); start();
    return { el: el, text: text, canvas: canvas, inf: function () { return inf; }, ready: function () { return ready; } };
  }

  function capture(el) {
    if (el.tagName === 'IMG') return;
    var cs = getComputedStyle(el);
    baseStyle.set(el, {
      style: cs.fontStyle, weight: cs.fontWeight, size: parseFloat(cs.fontSize),
      family: cs.fontFamily, ls: parseFloat(cs.letterSpacing) || 0
    });
  }

  var specs = [
    // Logo bewusst NICHT fluessig (Leon, 11.09.2026): es bleibt das ruhige Silber-Bild.
    // Zum Wiedereinschalten: { sel: 'img[class*="ai-logo-img-"], .sf-hero img.sf-logo', amp: 0.030, pad: 0.10, sharpen: 1, gold: false, detail: 0.55, flow: 1 },
    { sel: 'h1.sf-h1, h1[class*="ai-brand-name-"]',     amp: 0.030, pad: 0.14, sharpen: 1, gold: false },
    { sel: '.sf-eyebrow, [class*="ai-eyebrow-"]',       amp: 0.022, pad: 0.55, sharpen: 3, gold: true  },
    { sel: '.sf-tagline, [class*="ai-hero-tagline-"]',  amp: 0.026, pad: 0.30, sharpen: 2, gold: false }
  ];

  function go() {
    var made = [];
    specs.forEach(function (sp) {
      var el = document.querySelector(sp.sel);
      if (!el) return;
      capture(el);
      var m = makeMolten(el, sp);
      if (m) made.push(m);
    });
    window.SF_MOLTEN = made;
  }

  // Erst zeichnen, wenn die Marken-Schriften geladen sind
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
  else setTimeout(go, 300);
})();